<template>
  <div class="category-wrapper">
    <div class="row">
      <div class="col-md-12">
        <div class="form-row">
          <div class="col-md-4">
            <BaseInput
              type="text"
              v-model="params.q"
              label="Job category (Demo)"
              @enter="getLead5IntegrationData"
            />
          </div>
          <div class="col-md-4">
            <BaseInput
              type="text"
              v-model="params.l"
              label="Zip Code (Demo)"
              @enter="getLead5IntegrationData"
            />
          </div>
          <div class="col-md-4 form-group d-flex">
            <BaseButton
              type="submit"
              style-type="simple"
              customClass="align-self-end"
              @click.native="getLead5IntegrationData"
            >Adjust Example</BaseButton>
          </div>
        </div>
      </div>
    </div>
    <div class="contentSection">
      <div class="contentSection" style="background-color:#F5F5F5;">
        <div class="col-md-12 text-left">
          <div class="row">
            <div class="col-md-3 text-center d-flex justify-content-center">
              <div class="align-self-center">
                <div class="image-preview">
                  <img id="img" class="pointer" :src="exampleForm.logo">
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex flex-column align-items-start">
              <div class="w-100">
                <h2>
                  <a :href="exampleForm.url" class="p-0 w-100">{{exampleForm.jobtitle}}</a>
                </h2>
              </div>
              <div class="w-100">
                <span>
                  <p>{{cityAndState}}</p>
                </span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="input-group">
                <a class="apply-now-button" :href="exampleForm.url" type="text" required>Apply Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Leads from '@/resources/Lead5.js'

export default {
  data () {
    return {
      params: {
        q: 'driver',
        l: '84059',
        CID: this.offer.cid
      },
      exampleForm: {
        logo: '@/assets/imgs/img-placeholder.png',
        jobtitle: 'Example Job title',
        city: 'Provo',
        state: 'UT',
        company: 'DMS'
      }

    }
  },
  props: ['offer', 'image'],
  beforeMount () {
    this.getLead5IntegrationData()
  },
  methods: {
    getLead5IntegrationData () {
      Leads.getLead5Jobs(this.params).then(res => {
        this.exampleForm = res[0].response.results[0]
      })
    }
  },
  computed: {
    cityAndState () {
      return this.exampleForm.company + ' | ' + this.exampleForm.city + ',' + this.exampleForm.state
    }
  }
}
</script>
<style lang="scss" scoped>
.category-wrapper {
  .apply-now-button {
    background-color: #37abdd;
    color: white;
    padding: 10px 24px;
    border-radius: 8px;
    margin: 5px;
    &:hover {
      color: white;
      cursor: pointer;
    }
  }
}
</style>
